import React, { useEffect } from 'react';
import OurCommitments from './OurCommitments'
import WhoweareBanner from './WhoweareBanner'
import AboutCompany from './AboutCompany';
 import OurLeadership from './OurLeadership';
//  import Testimonials from './Testimonials';

const WhoweAre = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts
 
  return (
    <div>
        <WhoweareBanner/>

        <AboutCompany/>
        <OurCommitments/>
        <OurLeadership/>
        {/* { <OurLeadership/> } */}
        {/* { <Testimonials/> } */}



        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
        </style>
    </div>
  )
}

export default WhoweAre